export default {
  // TITLE
  TitleControl: '',
  ShowTitleControl: { checked: true },
  StyleTitleControl: {
    fontSize: 20,
    color: '#000000',
    fontFamily: 'arial',
    bold: false,
    italic: false,
    underline: false,
    align: 'center',
  },
  // Drilldown
  DrilldownStyle: 'auto',
  // GENERAL
  SortColumnsControl: 'Não ordenado',
  CustomSortColumnControl: {
    checked: false, kpiCategories: [],
  },
  SortValuesControl: 'Não ordenado',
  CustomSortControl: {
    checked: false, kpiCategories: [],
  },
  // SortDDControl: 'auto',
  StartAngleControl: 0,
  EndAngleControl: 270,
  InnerRadiusControl: { value: 0.3 },
  PaddingControl: { value: 0.1 },
  PaddingAngleControl: { value: 0 },
  Margin: {
    top: 50,
    right: 110,
    bottom: 50,
    left: 60,
  },
  MaxValueControl: { checked: true, value: 0 },
  DataFormat: 'absolute', // { type: 'absolute', target: 'global' },
  DataPercentFormat: 'global',
  DataAbsoluteFormat: 'number',
  DataFormatAlt: 'none',
  DataPercentFormatAlt: 'global',
  DataAbsoluteFormatAlt: 'number',
  DurationUnit: 'hours',
  InvertVariation: false,
  // STYLE
  BorderWidthControl: { value: 0 },
  BorderColorControl: { from: 'color', modifiers: [['darker', 1.6]] },
  EnableTrackControl: true,
  TrackColorControl: '#000000',
  TrackOpacityControl: 0.2,
  PalletsControl: 'default',
  ColorTheme: { scheme: 'nivo' },
  GradientPickerControl: {
    color1: '#4711B2',
    color2: '#FF9626',
    color3: null,
  },
  Colors: {},
  // DDPalletsControl: 'auto',
  // DDColorTheme: { scheme: 'nivo' },
  // DDGradientPickerControl: {
  //   color1: '#4711B2',
  //   color2: '#FF9626',
  //   color3: null,
  // },
  UseGlobalColor: true,
  UseGlobalFont: true,
  // LABEL
  EnableLabelControl: { checked: true },
  LabelTextColorControl: { from: 'color', modifiers: [['darker', 1.6]] },
  LabelsFontFamilyControl: { value: 'sans-serif' },
  LabelsFontSizeControl: { value: 15 },
  LabelRotationControl: 0,
  LabelTranslateX: 0,
  LabelTranslateY: 0,
  EnableLabelMinControl: false,
  LabelMinPercentControl: 0,
  PrefixControl: '',
  SufixControl: '',
  Decimals: 'auto',
  separadorNumericoCasas: 0,
  LabelCurrencyControl: 'Nenhum',
  LabelGroupingControl: '',
  LabelLineBreak: false,
  // AXIS
  EnableGridR: true,
  EnableGridC: true,
  EnableAxisStart: true,
  EnableAxisEnd: false,
  AxisRadialTickSize: 5,
  AxisRadialTickPadding: 5,
  AxisRadialTickRotation: 0,
  EnableAxisOuter: true,
  EnableAxisInner: false,
  AxisCircularTickSize: 5,
  AxisCircularTickPadding: 5,
  AxisCircularTickRotation: 0,
  AxisGlobalRadialFontFamily: 'arial',
  AxisGlobalRadialFontSize: 12,
  AxisGlobalRadialFontColor: '#333333',
  // LEGEND
  LegendControl: { checked: true },
  LegendPlacementControl: {
    value: {
      label: 'Direita',
      translateX: 110,
      translateY: 0,
      selectedPosition: 'right',
      direction: 'column',
      anchor: 'right',
    },
  },
  LegendsFontFamilyControl: { value: 'sans-serif' },
  LegendsFontSizeControl: { value: 12 },
  LegendBold: false,
  LegendItalic: false,
  LegendFontColor: '#999',
  LegendMaxLines: 1,
  LegendsSpacingControl: { value: 10 },
  LegendSymbolControl: 'circle',
  // TOOLTIP / INTERACTIVE
  InteractiveControl: true,
  InteractivePrefixControl: '',
  InteractiveSufixControl: '',
  InteractiveDecimals: 'auto',
  InteractiveSeparadorNumericoCasas: 0,
  InteractiveCurrencyControl: 'Nenhum',
  InteractiveGroupingControl: '',
  Animate: false,
  MotionConfig: 'default',
};
